import { Capacitor } from '@capacitor/core';
import { modifier } from 'ember-modifier';

/**
 * Adds a "Click to interact" overlay on top of a map container.
 * Prevents accidental scroll capture when scrolling past the map.
 * Clicking the overlay activates the map; moving the mouse out deactivates it.
 * No-op on native Capacitor (Android/iOS) where touch events work natively.
 */
const OVERLAY_BASE =
  'absolute inset-0 z-[999] flex items-center justify-center bg-black/25 text-white text-sm font-semibold tracking-wide cursor-pointer transition-opacity duration-200 rounded-[inherit]';
const OVERLAY_HIDDEN = ['opacity-0', 'pointer-events-none'];

const mapClickOverlay = modifier((element: HTMLElement) => {
  if (Capacitor.isNativePlatform()) return;

  element.classList.add('relative');

  const overlay = document.createElement('div');
  overlay.className = OVERLAY_BASE;
  overlay.textContent = 'Click to interact';
  element.appendChild(overlay);

  const activate = () => overlay.classList.add(...OVERLAY_HIDDEN);

  element.addEventListener('click', activate);

  return () => {
    element.removeEventListener('click', activate);
    overlay.remove();
  };
});

export default mapClickOverlay;
